// apps/website/src/chat/ChatWidget.tsx

import '@dopomogai/chatbot';

import { SiteChatContainer, type ToolRegistry } from '@dopomogai/chatbot';
import { interactiveToolRegistry } from '@dopomogai/chat-react';

import { API_BASE, DEFAULT_TEMPLATE_ID, ENABLE_CHATBOT } from '../config/env';
import { getSiteOrigin } from '../config/site';
import { useGlobalHeadlessContext, useGlobalHeadlessTools } from './headless';

export function ChatWidget() {
  const headlessContext = useGlobalHeadlessContext();
  const headlessTools = useGlobalHeadlessTools(headlessContext);
  const chatWidgetDisabled = true;

  if (chatWidgetDisabled || !ENABLE_CHATBOT) return null;

  return (
    <>
      <div id="global-chat-fallback-root" />
      {ENABLE_CHATBOT && (
        <SiteChatContainer
          authMode="widget"
          widgetInit={{ templateId: DEFAULT_TEMPLATE_ID, apiBaseUrlOverride: API_BASE }}
          headerTitle="DopomogAI Concierge"
          className="font-sans"
          toolUi={{ frontendActions: 'simple-replay', otherTools: 'simple' }}
          brandHref={getSiteOrigin()}
          initialPrompts={[
            'What can this agent do?',
            'Recommend a bundle for my industry',
            'How long does setup take?',
          ]}
          primaryColor="#10B981"
          headerStyle={{ backgroundColor: '#E0F2FE' }}
          inputStyle={{ backgroundColor: '#E2E8F0' }}
          userMessageStyle={{ backgroundColor: '#3B82F6', color: '#FFFFFF' }}
          assistantMessageStyle={{ backgroundColor: '#F1F5F9', color: '#1E293B' }}
          initialMessage={{ content: 'Hi! I’m your AI concierge — how can I help?' }}
          mode="full"
          position="bottom-right"
          isResizable
          showAgentSelector={false}
          showBrandFooter
          agentAvatar="https://i.ibb.co/BKFJyj4d/Open-AI-Playground-2025-08-20-at-16-09-07.png"
          toolRegistry={interactiveToolRegistry as ToolRegistry}
          headlessTools={headlessTools}
          headlessContext={headlessContext}
          // NEW: enable per-turn page context collection via props
          pageContext={{ enabled: true, mode: 'full', options: { maxChars: 8000, includeLinks: true } }}
        />
      )}
    </>
  );
}

export default ChatWidget;
